export type CsvValue = string | number | null | undefined;

/**
 * One cell. Market titles and names come from strangers, and a spreadsheet would run one
 * starting with = as a formula, so text that could be read that way gets a leading quote.
 * Numbers stay numbers, negatives included.
 */
export function csvCell(value: CsvValue): string {
	if (value === null || value === undefined) return "";
	if (typeof value === "number") return Number.isFinite(value) ? String(value) : "";
	const safe = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
	return /[",\r\n]/.test(safe) ? `"${safe.replaceAll('"', '""')}"` : safe;
}

export function toCsv(headers: string[], rows: CsvValue[][]): string {
	return [headers, ...rows].map((r) => r.map(csvCell).join(",")).join("\r\n");
}

/** Epoch seconds as ISO 8601, so a spreadsheet does not show a bare ten-digit number. */
export const isoSeconds = (s: number | null | undefined): string | null => (s ? new Date(s * 1_000).toISOString() : null);

export function saveFile(name: string, text: string, type: string): void {
	const url = URL.createObjectURL(new Blob([text], { type }));
	const a = document.createElement("a");
	a.href = url;
	a.download = name;
	a.click();
	URL.revokeObjectURL(url);
}

/** polygains-whales-2026-11-04.csv, dated in the reader's own day. */
export function fileName(view: string, ext: string, now: Date): string {
	const pad = (n: number) => String(n).padStart(2, "0");
	return `polygains-${view}-${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}.${ext}`;
}
